import { getSessionStorage } from 'services/local-preferences'
import {
  FACEBOOK_PIXEL_TEST_CODE_KEY,
  postEventData,
} from '.'
import * as ACTIONS from './actions'

export default function watchCreateServerEvent ({ after }) {
  return after([
    ACTIONS.CREATE_SERVER_EVENT,
  ], async ({ action, state }) => {
    const { auth } = state
    const { payload } = action
    const { data } = payload
    const facebookPixelTestCode = getSessionStorage(FACEBOOK_PIXEL_TEST_CODE_KEY)
    postEventData({ auth, data, facebookPixelTestCode })
  })
}
